<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Ver Jornada Folio:{{ folio }}
            <div>
              <BackButton :to="{ name: 'CalculoAdministrativo' }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </BackButton>
            </div>
          </CCardHeader>

          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CCol sm="12" class="text-right">
              {{ this.item.author ? this.item.author.correo : "" }}
            </CCol>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput
                  v-model="fechahora"
                  disabled
                  type="date"
                  :horizontal="{ input: 'col-sm-12' }"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <label>Trabajador:</label>
                <CInput v-model="trabajador" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Horas:</label>
                <CInput v-model="horas_normales" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Horas Extras:</label>
                <CInput v-model="horas_extras" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Comentarios:</label>
                <CTextarea v-model="comentarios" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <h4 class="inventario-panel-subtitle">Documentos aplicados:</h4>
              </CCol>
            </CRow>

            <CRow>
              <CCol class="inventario-panel">
                <TableCalculoAdministrativo
                  v-for="(row, i) in documentos_aplicados_"
                  :key="`table_aplicados_${i}`"
                  :row="row"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <h4 class="inventario-panel-subtitle">Documentos fecha:</h4>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="inventario-panel">
                <TableCalculoAdministrativo
                  v-for="(row, i) in documentos_fecha_"
                  :key="`table_fecha_${i}`"
                  :row="row"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import moment from "moment";
import TableCalculoAdministrativo from "@/views/operaciones/calculos-administrativos/TableCalculoAdministrativo.vue";
import "vue-select/dist/vue-select.css";
import DocsTranslationMixin from "@/mixins/DocsTranslationMixin";

export default {
  name: "VerAsistencia",
  mixins: [DocsTranslationMixin],
  components: {
    TableCalculoAdministrativo
  },
  data() {
    return {
      folio: this.$route.params.id,

      fechahora: "",
      isLoading: false,
      isLoadingPage: false,
      documentos_aplicados: [],
      documentos_fecha: [],
      trabajador: null,
      horas_normales: null,
      horas_extras: null,
      comentarios: '',
      successModal: false,
      warningModal: false,
      nanoid: undefined,
      error: "",

      item: {},
    };
  },
  created() {
    this.isLoadingPage = true;
    this.isLoading = true;

    const ubi = [
      this.$store.dispatch("customDocumentoHTTP", {
        schema: "jornadas",
        filter: {
          wherein: [
            {
              field: "payload->encabezado->ubicacion_raiz_id",
              value: [this.ubicacionRaiz]
            }
          ],
          where: [
            {
              field: "folio",
              value: this.folio,
              operator: "="
            }
          ]
        },
        ["with-storage"]: ["*"]
      })
    ];

    // ubi.push(ubicacionTemplateNoRaiz);

    Promise.all(ubi)
      .then(([item]) => {
        this.item = item.data[0];
        this.documentos_aplicados = this.item.payload.encabezado.documentos_aplicados;
        this.documentos_fecha = this.item.payload.encabezado.documentos_fecha;

        this.trabajador = this.item.payload.encabezado._relaciones.trabajador.payload.nombre;

        this.horas_normales = this.item.payload.encabezado.horas_normales;
        this.horas_extras = this.item.payload.encabezado.horas_extras;
        this.comentarios = this.item.payload.encabezado.comentarios;
        
        this.fechahora = moment(
          this.item.payload.encabezado.fechahora,
        ).format("YYYY-MM-DD");
      })
      .finally(() => (this.isLoading = false));
  },
  computed: {
    documentos_aplicados_() {
      return this.documentosRelacionados(this.documentos_aplicados)
      
    },
    documentos_fecha_() {
      return this.documentosRelacionados(this.documentos_fecha)
      
    },
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.inventario-panel-row {
  margin-bottom: 10px;
  h4.inventario-panel-subtitle {
    width: 100%;
  }
  section {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 10px;
  }
}
.catalogo-text {
  font-size: 1.2rem !important;
}
</style>
